/**
 * @generated SignedSource<<05d0b32e5817205518fb96077cd7364b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type usePublishReadLabelsFragment$data = {
  readonly labels: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly label: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "usePublishReadLabelsFragment";
};
export type usePublishReadLabelsFragment$key = {
  readonly " $data"?: usePublishReadLabelsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePublishReadLabelsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "usePublishReadLabelsFragment",
  "selections": [
    {
      "concreteType": "PaginatedLabelList",
      "kind": "LinkedField",
      "name": "labels",
      "plural": false,
      "selections": [
        {
          "concreteType": "Label",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "id"
            },
            {
              "kind": "ScalarField",
              "name": "label"
            }
          ]
        }
      ]
    }
  ],
  "type": "Content"
};

(node as any).hash = "bd62e6bdf52db98920b7aaccd17d29bd";

export default node;
